export default __webpack_public_path__ + "static/media/89.5b81f22f.jpg";